import { OsanoWindow } from '../types/OsanoWindow';

// whether the visitor has accepted the consent manager's Marketing category,
// shown to them as Targeted Advertising. Turning on Do Not Sell turns it off,
// and where no state privacy law applies it's accepted by default. It's already
// set when the consent manager's script fires load, which is when
// consentManagerPlugin releases the pixels. Without the consent manager, for
// example when an ad blocker stops it, this returns true so the pixels send as
// they did before it, the same way consentManagerPlugin fails open
export const hasMarketingConsent = (): boolean => {
  const { Osano } = window as OsanoWindow;

  return Osano ? Osano.cm.marketing : true;
};
